import { ContentState, EditorState } from 'draft-js'
// import draftToHtml from 'draftjs-to-html'
import htmlToDraft from 'html-to-draftjs'
import { t } from 'i18next'
import { useMemo, useState } from 'react'
import { Editor as ReactEditor } from 'react-draft-wysiwyg'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import styled from 'styled-components'

const StyledLabel = styled.label`
  color: var(--color-gray-111);
  font-weight: 600;
  font-size: 1.4rem;
  span {
    color: var(--color-red-107);
  }
`
const StyledEditor = styled.div`
  margin-top: 4px;
  .rdw-fontfamily-optionwrapper {
    width: 160px;
  }
`
interface IProps {
  title?: string
  value?: string
  initValue?: string
  required?: boolean
  onChange?: (value: string) => void
}

const Editor = (props: IProps) => {
  const { value, initValue, title, required, onChange } = props
  const contentState = useMemo(() => {
    const contentBlock = htmlToDraft(initValue || value || '')
    return ContentState.createFromBlockArray(contentBlock.contentBlocks)
  }, [value])

  const [editorState, setEditorState] = useState(
    EditorState.createWithContent(contentState)
  )
  return (
    <>
      <StyledLabel className="input-label">
        {t(title || '')} {required && <span>*</span>}
      </StyledLabel>
      <StyledEditor>
        <ReactEditor
          editorState={editorState}
          toolbar={{
            options: [
              'inline',
              'blockType',
              'fontSize',
              'fontFamily',
              'list',
              'textAlign',
              'colorPicker',
              'link',
              'embedded',
              'emoji',
              'image',
              'remove',
              'history'
            ],
            fontFamily: {
              options: ['Manrope variant0'],
              className: undefined,
              component: undefined,
              dropdownClassName: undefined
            }
          }}
          toolbarClassName="toolbar-class-name"
          wrapperClassName="wrapper-class-name"
          editorClassName="editor-class-name"
          onEditorStateChange={(_editorState) => {
            onChange &&
              onChange(_editorState.getCurrentContent().getPlainText().trim())
            setEditorState(_editorState)
          }}
        />
      </StyledEditor>
    </>
  )
}

export default Editor
